import React, { PropTypes } from 'react';
import Modal from 'common/components/Modal';
import { Form, Checkbox, Button } from 'semantic-ui-react';
import Dropdown from 'common/components/Dropdown';
import Datepicker from 'common/components/Datepicker';
import { List } from 'immutable';
import cx from 'classnames';

class StudyModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMultiSchedule: false,
      fixedScheduleMode: props.sites && props.sites.length > 1 ? true : false,
      selectedSites: props.sites,
      generalStudySchedule: {},
      bySiteStudySchedule: {},
    };

    this.onConfChange = this.onConfChange.bind(this);
    this.onSiteChange = this.onSiteChange.bind(this);
    this.onSiteAdd = this.onSiteAdd.bind(this);
    this.onSiteRemove = this.onSiteRemove.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onWorkerChange = this.onWorkerChange.bind(this);
    this.onUnknownToggle = this.onUnknownToggle.bind(this);
  }

  onConfChange(_, value) {
    this.setState({ isMultiSchedule: value.checked });
  }

  onSiteChange = value => {};

  onSiteAdd = value => {
    const site = this.props.sites.find(
      s => s.id === Number.parseInt(value, 10)
    );
    if (site) {
      const selected = List(this.state.selectedSites).push(site);
      this.setState({ selectedSites: selected.toArray() });
    }
  };

  onSiteRemove = value => {
    const selected = List(this.state.selectedSites).filter(
      s => s.id !== Number.parseInt(value, 10)
    );
    this.setState({ selectedSites: selected.toArray() });
  };

  onDateChange = site => evt => {
    if (site) {
      const siteSchedule = {
        ...this.state.bySiteStudySchedule[site.id],
        date: evt.target.value,
      };
      this.setState({
        bySiteStudySchedule: {
          ...this.state.bySiteStudySchedule,
          [site.id]: siteSchedule,
        },
      });
    } else {
      this.setState({
        generalStudySchedule: {
          ...this.state.generalStudySchedule,
          date: evt.target.value,
        },
      });
    }
  };

  onWorkerChange = site => value => {
    if (site) {
      const siteSchedule = {
        ...this.state.bySiteStudySchedule[site.id],
        worker: value,
      };
      this.setState({
        bySiteStudySchedule: {
          ...this.state.bySiteStudySchedule,
          [site.id]: siteSchedule,
        },
      });
    } else {
      this.setState({
        generalStudySchedule: {
          ...this.state.generalStudySchedule,
          worker: value,
        },
      });
    }
  };

  onUnknownToggle = (fieldName, site) => () => {
    if (site) {
      const currentSchedule = this.state.bySiteStudySchedule[site.id];
      const siteSchedule = {
        ...currentSchedule,
        [fieldName]:
          currentSchedule && currentSchedule[fieldName]
            ? !currentSchedule[fieldName]
            : true,
      };
      this.setState({
        bySiteStudySchedule: {
          ...this.state.bySiteStudySchedule,
          [site.id]: siteSchedule,
        },
      });
    } else {
      const currentSchedule = this.state.generalStudySchedule;
      const schedule = {
        ...currentSchedule,
        [fieldName]:
          currentSchedule && currentSchedule[fieldName]
            ? !currentSchedule[fieldName]
            : true,
      };
      this.setState({ generalStudySchedule: schedule });
    }
  };

  render() {
    const { selectedSites, isMultiSchedule } = this.state;

    const renderDefault = () => <div className="default text" />;

    const renderItem = item => {
      const filtered = !!selectedSites.filter(s => s.id === item.id);
      return (
        <div
          key={item.id}
          data-value={item.id}
          className={cx('item', { filtered })}
        >
          {item.name}
        </div>
      );
    };

    const renderWorkerItem = item => (
      <div key={item.id} data-value={item.id} className="item">
        {item.display_name}
      </div>
    );

    const renderMultiValue = item => (
      <a
        key={`selected-label-${item.id}`}
        className="ui label"
        data-value={item.id}
      >
        {item.name}
        <i className="delete icon" />
      </a>
    );

    const renderGeneralConf = () => {
      const {
        worker,
        workerUnknown,
        dateUnknown,
        date,
      } = this.state.generalStudySchedule;

      return (
        <div className="ui grid">
          <div className="seven wide column">
            <div className="field">
              <label>Date de l'étude</label>
              <div className="ui buttons">
                <div className="ui button">
                  <div className="fluid field">
                    <Datepicker
                      name="studyDate"
                      disabled={dateUnknown}
                      value={date}
                      onChange={this.onDateChange()}
                    />
                  </div>
                </div>
                <div className="or" data-text="ou" />
                <Button
                  className={cx({ states: dateUnknown })}
                  onClick={this.onUnknownToggle('dateUnknown')}
                >
                  Je ne sais pas
                </Button>
              </div>
            </div>
          </div>
          <div className="one wide column" />
          <div className="seven wide column">
            <div className="worker field">
              <label>Technicien</label>
              <div className="ui buttons">
                <div className="ui button">
                  <Dropdown
                    name="worker"
                    value={worker}
                    onChange={this.onWorkerChange()}
                    items={this.props.workers}
                    renderDefault={renderDefault}
                    renderItem={renderWorkerItem}
                    fluid
                    selection
                    disabled={workerUnknown}
                  />
                </div>
                <div className="or" data-text="ou" />
                <Button
                  className={cx({ states: workerUnknown })}
                  onClick={this.onUnknownToggle('workerUnknown')}
                >
                  Je ne sais pas
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const renderOneMultiSiteConf = site => {
      const studyState = this.state.bySiteStudySchedule[site.id];

      const date = studyState && studyState.date;
      const dateUnknown = studyState && studyState.dateUnknown;
      const workerUnknown = studyState && studyState.workerUnknown;

      return (
        <div className="ui middle aligned grid">
          <div className="two wide column">{site.name}</div>
          <div className="six wide column">
            <div className="field">
              <label>Date de l'étude</label>
              <div className="ui buttons">
                <div className="ui button">
                  <div className="fluid field">
                    <Datepicker
                      identifier={`study-datepicker-${site.id}`}
                      name="studyDate"
                      disabled={dateUnknown}
                      value={date}
                      onChange={this.onDateChange(site)}
                    />
                  </div>
                </div>
                <div className="or" data-text="ou" />
                <Button
                  className={cx({ states: dateUnknown })}
                  onClick={this.onUnknownToggle('dateUnknown', site)}
                >
                  Je ne sais pas
                </Button>
              </div>
            </div>
          </div>
          <div className="one wide column" />
          <div className="six wide column">
            <div className="worker field">
              <label>Technicien</label>
              <div className="ui buttons">
                <div className="ui button">
                  <Dropdown
                    name="worker"
                    value={(studyState && studyState.worker) || ''}
                    onChange={this.onWorkerChange(site)}
                    items={this.props.workers}
                    renderDefault={renderDefault}
                    renderItem={renderWorkerItem}
                    fluid
                    selection
                    canDelete={true}
                    disabled={workerUnknown}
                  />
                </div>
                <div className="or" data-text="ou" />
                <Button
                  className={cx({ states: workerUnknown })}
                  onClick={this.onUnknownToggle('workerUnknown', site)}
                >
                  Je ne sais pas
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const renderMultiSiteConf = sites => {
      return sites.map(site => (
        <div key={`site-config-${site.id}`}>{renderOneMultiSiteConf(site)}</div>
      ));
    };

    const renderSchedule = sites =>
      isMultiSchedule ? renderMultiSiteConf(sites) : renderGeneralConf();

    return (
      <Modal isOpened>
        <div className="header">Planifier une étude</div>
        <div className="content">
          <Form className="inputOrButtonInGrid">
            <div className="ui bottom aligned grid">
              <div className="ten wide column">
                <div className="required field">
                  <label>Site(s) lié(s) à la demande</label>
                  <Dropdown
                    name="sites[]"
                    value={selectedSites.map(s => s.id).join(',')}
                    values={selectedSites}
                    onChange={this.onSiteChange}
                    onAdd={this.onSiteAdd}
                    onRemove={this.onSiteRemove}
                    items={this.props.sites}
                    renderDefault={renderDefault}
                    renderItem={renderItem}
                    renderValue={renderMultiValue}
                    fluid
                    multiple
                    search
                    selection
                    placeholder="Site(s) lié(s) à la demande"
                  />
                </div>
              </div>
              <div className="six wide column">
                <div style={{ verticalAlign: 'center' }} className="field">
                  <Checkbox
                    className="center aligned"
                    label="Organisation différente par site"
                    onChange={this.onConfChange}
                    checked={isMultiSchedule}
                    toggle
                    disabled={this.props.sites.length <= 1}
                  />
                </div>
              </div>
            </div>
            {renderSchedule(selectedSites)}
          </Form>
        </div>
        <div className="actions">
          <Button className="cancel" onClick={this.props.onCancel}>
            Annuler
          </Button>
          <Button
            className="primary approve icon labeled"
            onClick={this.props.onApprove(this.state)}
          >
            <i className="icon save" />
            Enregistrer
          </Button>
        </div>
      </Modal>
    );
  }
}

StudyModal.propTypes = {
  sites: PropTypes.array.isRequired,
  workers: PropTypes.array.isRequired,
};

export default StudyModal;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/StudyModal.js